import React, { useState, useEffect } from "react";

import config from "../../config/config";

import { Swiper, SwiperSlide } from 'swiper/react'
import {Navigation, Pagination, A11y, Thumbs } from 'swiper/modules'
// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';

import {connect} from 'react-redux';
import './gallery.css';


const  Gallery = ({ Images, folder }) => {
    const [activeThumb, setActiveThumb] = useState()
	const [thumbsSwiper, setThumbsSwiper] = useState(null);
    // console.log('Images', Images , Images.length )
    return (
        <>
        <Swiper
            loop={true}
            spaceBetween={10}
            navigation={true}
            modules={[Navigation, Thumbs]}
            grabCursor={true}
            autoHeight={true}
            // calculateHeight={true}
            thumbs={{ swiper: activeThumb }}
            // className='product-images-slider'
        >
            {
                Images.map((item, index) => (
                    <SwiperSlide key={index}>
                        <img src={`${config.uploadUrl}${folder}${item.image_url}`} alt="product images" />
                    </SwiperSlide>
                ))
            }
        </Swiper>
        <Swiper
            onSwiper={setActiveThumb}
            loop={true}
            navigation={true}
            spaceBetween={10}
            slidesPerView={4}
            modules={[Navigation, Thumbs]}
            className='product-images-slider-thumbs'
        >
            {
                Images.map((item, index) => (
                    <SwiperSlide key={index}>
                        <div className="product-images-slider-thumbs-wrapper">
                            <img src={`${config.uploadUrl}${folder}${item.image_url}`} alt="product images" />
                        </div>
                    </SwiperSlide>
                ))
            }
        </Swiper>
	</>
				
				
    );
  
}


function mapStateToProps(state) {
	return {
		detail: state.property.detail
	};
}
 
function mapDispatchToProps(dispatch) {
	return {
		// getOfficialMerchandise: () => dispatch(actions.getProducts())
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(Gallery);
